import React from 'react';
import ReactDOM from 'react-dom/client';
import TdxMain from './TdxMain';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './css/stokeStyle.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@mdi/font/css/materialdesignicons.min.css';

//import '@mdi/font/css/materialdesignicons.min.css';

//import './css/stokeApp.css';
//import 'https://themesbrand.com/assets/css/bootstrap.min.css';


import { BrowserRouter } from 'react-router-dom'; // ✅ 추가
import { AuthProvider } from './context/AuthContext'; // ✅ 추가
import { NotificationProvider } from './context/NotificationContext'; // ✅ 알림 컨텍스트 추가
import { setupClientIpHeader } from './api/clientIpHeader';

setupClientIpHeader();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter> {/* ✅ Router로 감싸기 */}
      <AuthProvider>
        <NotificationProvider>
          <TdxMain />
        </NotificationProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

